import { lazy, Suspense } from 'react';
import { Spin } from 'antd';

const FileViewer = lazy(() => import('./FileViewer'));

// Code-split wrapper: pdf.js (~1 MB with worker) only downloads the first time a
// file is actually viewed, not with the app shell. Render conditionally, same
// props as FileViewer: { title, url, fileName?, onClose }.
export default function FileViewerLazy(props) {
  return (
    <Suspense
      fallback={
        <div style={{ position: 'fixed', inset: 0, zIndex: 4500, background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin />
        </div>
      }
    >
      <FileViewer {...props} />
    </Suspense>
  );
}
